var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section4-content"},[_c('img',{staticClass:"item-view-img",attrs:{"src":require("../../assets/product/section4_2.png"),"alt":"img"}})])
}]

export { render, staticRenderFns }